import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import formsActionCreators from '../../store/forms/action-creators';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import FormIndex from './FormIndex';
import FormDetail from './FormDetail';

class FormContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentWillMount() {
    this.props.fetchForms();
  }

  componentWillUnmount() {
    // this.props.unmountUserContainer();
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {this.props.userContext.hasScope(['admin']) ? (
          <div>
            <Route component={FormIndex} exact path="/admin/forms" />
            <Route component={FormDetail} path="/admin/forms/:formGuid" />
          </div>
        ): (
            <div>
              <Route component={FormIndex} exact path="/forms" />
              <Route component={FormDetail} path="/forms/:formGuid" />
            </div>
          )}
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: !!state.forms.isLoading.length,
    userContext: state.common.userContext
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchForms: () => {
      return dispatch(formsActionCreators.fetchForms());
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FormContainer));
